import { createPinia } from 'pinia';
import { createApp } from 'vue';
import ScrollbarPlugin from './vue-components/header/scrollbarPlugin';
import HeaderMenu from './vue-components/header/HeaderMenu';
import vhFixForIOS from './modules/vh-fix-for-ios';
import vueAppInitiator from './modules/vue-app-initiator';
import vueUIInitiator from './modules/vue-ui-initiator';
// import fixedHeader from './modules/fixedHeader';
import mainNav from './modules/main-nav';
import toggleHeight from './modules/toggle-height';
import modalGallery from './modules/modal-gallery';
import anchorLinks from './modules/anchor-links';
import stickyNav from './modules/sticky-nav';
import DatepickerSelect from './vue-components/DatepickerSelect';
import MySelect from './vue-components/MySelect';
import MySearch from './vue-components/MySearch';
import MyAccordion from './vue-components/MyAccordion';
import TooltipComponent from './vue-components/TooltipComponent';
import MyAccordionDocs from './vue-components/MyAccordionDocs';
import MyAccordionSimple from './vue-components/MyAccordionSimple';
import TradingView from './vue-components/TradingView';
import TradingCalendarBlock from './vue-components/TradingCalendarBlock';
import MyRangeSlider from './vue-components/MyRangeSlider';
import ViewSwitcher from './vue-components/ViewSwitcher';
import AuctionsGrid from './vue-components/AuctionsGrid';
import AuctionsList from './vue-components/AuctionsList';
import AuctionsMap from './vue-components/AuctionsMap';
import AuctionsBlock from './vue-components/AuctionsBlock';
import AuctionFormRequest from './vue-components/AuctionFormRequest';
import ProjectsFormRequest from './vue-components/ProjectsFormRequest';
import AuctionBlock from './vue-components/AuctionBlock';
import AuctionsFavourites from './vue-components/AuctionsFavourites';
import SliderWithThumbs from './vue-components/SliderWithThumbs';
import SubscriptionForm from './vue-components/SubscriptionForm';
import ProjectsMobileSlider from './vue-components/ProjectsMobileSlider';
import ProjectWithPopup from './vue-components/ProjectWithPopup';
import TableObjects from './vue-components/tables/TableObjects';
import TableTorgDocs from './vue-components/tables/TableTorgDocs';
import TableProjects from './vue-components/tables/TableProjects';
import CompareBlock from './vue-components/CompareBlock';
import Tabs from './vue-components/ui/Tabs';
import NavSelect from './vue-components/NavSelect';
import DropdownBtn from './vue-components/DropdownBtn';
import MyDropFile from './vue-components/ui/MyDropFile';
import ModalAskQuestion from './vue-components/modals/ModalAskQuestion';
import AuctionsFilters from './vue-components/AuctionsFilters';
import TradingCalendarInline from './vue-components/TradingCalendarInline';
import TradingCalendarPage from './vue-components/TradingCalendarPage';
import TakenDecisions from './vue-components/TakenDecisions';
import RegulatoryFramework from './vue-components/RegulatoryFramework';
import InvolveLand from './vue-components/InvolveLand';
import AuctionsArchive from './vue-components/AuctionsArchive';
import MainFilterSearcher from './vue-components/MainFilterSearcher';
import AuctionsListPage from './vue-components/AuctionsListPage';
import ButtonWithCounter from './vue-components/ButtonWithCounter';
import AuctionDetails from './vue-components/AuctionDetails';
import ObjectLocation from './vue-components/ObjectLocation';
import SubjectsMap from './vue-components/SubjectsMap';
import TransferredPlotsBlock from './vue-components/TransferredPlotsBlock';
import OtherAuctions from './vue-components/OtherAuctions';
import TradingListFull from './vue-components/TradingListFull';
import DownloadPresentationButton from './vue-components/DownloadPresentationButton';
import MyModal from './vue-components/modals/MyModal';
import ButtonAddToList from './vue-components/ButtonAddToList';
import CookieModal from './vue-components/modals/CookieModal';
import CookieModalPolicy from './vue-components/modals/CookieModalPolicy';
import MenuBurgerNav from './vue-components/MenuBurgerNav';
import TelegramBlock from './vue-components/TelegramBlock';
// import CompleteProjectPage from './vue-components/CompleteProjectPage'; // главный компонент страницы завершенные проекты
import AuctionsListPageCompleteProject from './vue-components/AuctionsListPageCompleteProject'; // главный компонент страницы завершенные проекты
import TransferredPlotsMapProjectComplete from './vue-components/TransferredPlotsMapProjectComplete';
import AuctionFormRequestCompleteProject from './vue-components/AuctionFormRequestCompleteProject';
import OtherAuctionsCompleteProject from './vue-components/OtherAuctionsCompleteProject';
// currency converter
import FormatCurrency from './vue-components/FormatCurrency';

import ZemlyaMainPage from './vue-components/zemlya/ZemlyaMainPage';

const pinia = createPinia();

// Немедленная инициализация Vue без ожидания DOMContentLoaded
(function () {
    // Проверяем, существует ли целевой элемент в DOM
    const headerVueElement = document.getElementById('header-menu');

    if (!headerVueElement) {
        // Если элемент еще не существует, используем MutationObserver
        // для отслеживания его появления в DOM
        const observer = new MutationObserver((mutations, observer) => {
            const element = document.getElementById('header-menu');
            if (element) {
                observer.disconnect(); // Прекращаем наблюдение
                initializeVue(element); // Инициализируем Vue
            }
        });

        // Начинаем наблюдать за изменениями в DOM
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    } else {
        // Элемент уже существует, инициализируем Vue немедленно
        initializeVue(headerVueElement);
    }

    function initializeVue(element) {
        // Получаем данные, переданные из PHP
        const header = createApp({ components: { HeaderMenu } });
        header.use(ScrollbarPlugin, {
            className: 'body-lock'
        });
        header.use(pinia);

        header.mount('#header-menu');

        // Переключаем тайтлы страницы
        const staticTitle = document.querySelector('.is-loading');
        if (staticTitle) {
            staticTitle.classList.remove('is-loading');
        }
    }
})();

document.addEventListener('DOMContentLoaded', () => {
    vhFixForIOS();
    setTimeout(() => {
        anchorLinks();
    }, 0);
    modalGallery();

    const vueApps = [
        {
            el: '#menu-burger-nav',
            components: {
                MenuBurgerNav
            }
        },
        {
            el: '#table-objects',
            components: {
                TableObjects
            }
        },
        {
            el: '#table-torg-docs',
            components: {
                TableTorgDocs
            }
        },
        {
            el: '#compare-block',
            components: {
                CompareBlock
            }
        }
    ];

    vueAppInitiator(vueApps, pinia);
    vueUIInitiator('js--search-init', MySearch, 'my-search', pinia);
    vueUIInitiator('js--select-init', MySelect, 'my-select', pinia);
    vueUIInitiator('js--accordion-init', MyAccordion, 'my-accordion', pinia);
    vueUIInitiator(
        'js--accordion-docs-init',
        MyAccordionDocs,
        'my-accordion-docs',
        pinia
    );
    vueUIInitiator(
        'js--accordion-simple',
        MyAccordionSimple,
        'my-accordion-simple',
        pinia
    );
    vueUIInitiator('js--tooltip', TooltipComponent, 'tooltip-component', pinia);
    vueUIInitiator(
        'js--trading-calendar-block',
        TradingCalendarBlock,
        'trading-calendar-block',
        pinia
    );
    vueUIInitiator('js--range-slider', MyRangeSlider, 'my-range-slider', pinia);
    vueUIInitiator('js--view-switcher', ViewSwitcher, 'view-switcher', pinia);
    vueUIInitiator('js--auctions-grid', AuctionsGrid, 'auctions-grid', pinia);
    vueUIInitiator('js--auctions-list', AuctionsList, 'auctions-list', pinia);
    vueUIInitiator('js--auctions-map', AuctionsMap, 'auctions-map', pinia);
    vueUIInitiator(
        'js--auctions-block',
        AuctionsBlock,
        'auctions-block',
        pinia
    );
    vueUIInitiator('js--auction-block', AuctionBlock, 'auction-block', pinia);
    vueUIInitiator(
        'js--auctions-favourites',
        AuctionsFavourites,
        'auctions-favourites',
        pinia
    );
    vueUIInitiator(
        'js--slider-with-thumbs',
        SliderWithThumbs,
        'slider-with-thumbs',
        pinia
    );
    vueUIInitiator('js--tabs', Tabs, 'tabs', pinia);
    vueUIInitiator('js--trading-view', TradingView, 'trading-view', pinia);
    vueUIInitiator('js--nav-select-init', NavSelect, 'nav-select', pinia);
    vueUIInitiator('js--dropdown-btn-init', DropdownBtn, 'dropdown-btn', pinia);
    vueUIInitiator(
        'js--auction-form-request',
        AuctionFormRequest,
        'auction-form-request',
        pinia
    );
    vueUIInitiator(
        'js--projects-form-request',
        ProjectsFormRequest,
        'projects-form-request',
        pinia
    );
    vueUIInitiator('js--my-drop-file', MyDropFile, 'my-drop-file', pinia);
    vueUIInitiator(
        'js--modal-ask-question',
        ModalAskQuestion,
        'modal-ask-question',
        pinia
    );
    vueUIInitiator(
        'js--auctions-filters',
        AuctionsFilters,
        'auctions-filters',
        pinia
    );
    vueUIInitiator(
        'js--trading-calendar-inline-init',
        TradingCalendarInline,
        'trading-calendar-inline',
        pinia
    );
    vueUIInitiator(
        'js--trading-calendar-page-init',
        TradingCalendarPage,
        'trading-calendar-page',
        pinia
    );
    vueUIInitiator(
        'js--taken-decisions',
        TakenDecisions,
        'taken-decisions',
        pinia
    );
    vueUIInitiator(
        'js--regulatory-framework',
        RegulatoryFramework,
        'regulatory-framework',
        pinia
    );
    vueUIInitiator('js--involve-land', InvolveLand, 'involve-land', pinia);
    vueUIInitiator(
        'js--subscription-form',
        SubscriptionForm,
        'subscription-form',
        pinia
    );
    vueUIInitiator(
        'js--auctions-archive',
        AuctionsArchive,
        'auctions-archive',
        pinia
    );
    vueUIInitiator(
        'js--datepicker-init',
        DatepickerSelect,
        'datepicker-select',
        pinia
    );
    vueUIInitiator(
        'js--projects-mobile-slider',
        ProjectsMobileSlider,
        'projects-mobile-slider',
        pinia
    );
    vueUIInitiator(
        'js--project-with-popup',
        ProjectWithPopup,
        'project-with-popup',
        pinia
    );
    vueUIInitiator(
        'js--table-projects',
        TableProjects,
        'table-projects',
        pinia
    );
    vueUIInitiator(
        'js--button-with-counter',
        ButtonWithCounter,
        'button-with-counter',
        pinia
    );
    vueUIInitiator(
        'js--auction-details',
        AuctionDetails,
        'auction-details',
        pinia
    );
    vueUIInitiator(
        'js--object-location',
        ObjectLocation,
        'object-location',
        pinia
    );
    vueUIInitiator('js--subjects-map', SubjectsMap, 'subjects-map', pinia);
    vueUIInitiator(
        'js--transferred-plots-block',
        TransferredPlotsBlock,
        'transferred-plots-block',
        pinia
    );
    vueUIInitiator(
        'js--main-filter-searcher',
        MainFilterSearcher,
        'main-filter-searcher',
        pinia
    );
    vueUIInitiator(
        'js--auctions-list-page',
        AuctionsListPage,
        'auctions-list-page',
        pinia
    );
    vueUIInitiator(
        'js--other-auctions',
        OtherAuctions,
        'other-auctions',
        pinia
    );
    vueUIInitiator(
        'js--trading-list-full',
        TradingListFull,
        'trading-list-full',
        pinia
    );
    vueUIInitiator(
        'js--download-presentation-button',
        DownloadPresentationButton,
        'download-presentation-button',
        pinia
    );
    vueUIInitiator('js--my-modal', MyModal, 'my-modal', pinia);
    vueUIInitiator('js--cookie-modal', CookieModal, 'cookie-modal', pinia);
    vueUIInitiator(
        'js--cookie-modal-policy',
        CookieModalPolicy,
        'cookie-modal-policy',
        pinia
    );
    vueUIInitiator(
        'js--button-add-to-list',
        ButtonAddToList,
        'button-add-to-list',
        pinia
    );
    vueUIInitiator(
        'js--complete-project-page',
        AuctionsListPageCompleteProject,
        'complete-project-page',
        pinia
    );
    vueUIInitiator(
        'js--ya-maps',
        TransferredPlotsMapProjectComplete,
        'transferred-plots-map',
        pinia
    );
    vueUIInitiator(
        'js--auction-form-request-cp',
        AuctionFormRequestCompleteProject,
        'auction-form-request-cp',
        pinia
    );
    vueUIInitiator(
        'js--other-auctions-cp',
        OtherAuctionsCompleteProject,
        'other-auctions-cp',
        pinia
    );
    vueUIInitiator('js--telegram-block', TelegramBlock, 'telegram-block');
    vueUIInitiator('js--format-currency', FormatCurrency, 'format-currency');
    vueUIInitiator('js--zemlya-main-page', ZemlyaMainPage, 'zemlya-main-page');
});

window.addEventListener('load', () => {
    mainNav();
    toggleHeight();
    stickyNav();
});
